import React from 'react';
import {ICreateExpenseData, ICustomer, IExpense} from '../../@types';
import {createExpense, editExpense} from '../../backend-services';
import { clearFieldError } from '../../utils/handleErrors';

export const validateExpenseBasicInfo = (
  formData: ICreateExpenseData,
  setValidationResults: React.Dispatch<React.SetStateAction<ICreateExpenseData>>,
) => {
  const errors = {
    customerId: '',
    category: '',
    currency: '',
    date: '',
    lineItems: '',
    isBillable: false,
    reference: '',
    vendorName: '',
    paymentMethod: '',
    exchangeRate:0,
  };
  let isValid = true;

  if (!formData.date) {
    errors.date = 'Expense Date required';
    isValid = false;
  }
  // if (!formData.currency) {
  //   errors.currency = 'Currency is required';
  //   isValid = false;
  // }
  if (!formData.category) {
    errors.category = 'Category is required';
    isValid = false;
  }
  if (!formData.paymentMethod) {
    errors.paymentMethod = 'Payment Method is required';
    isValid = false;
  }
  if (!formData.vendorName) {
    errors.vendorName = 'Vendor is required';
    isValid = false;
  }

  clearFieldError('vendorName', errors, setValidationResults);
  clearFieldError('customerId', errors, setValidationResults);

  setValidationResults(errors as ICreateExpenseData);
  return isValid;
};

export const validateExpenseItemDetails = (
  formData: ICreateExpenseData,
  setValidationResults: React.Dispatch<React.SetStateAction<ICreateExpenseData>>,
) => {
  const errors = {
    lineItems: '',
  };
  let isValid = true;

  if (formData.lineItems.some((item: { quantity: string; }) => parseFloat(item.quantity) === 0)) {
    errors.lineItems = 'At least one Line Item is required';
    isValid = false;
  } else {
    let lineItemsErrors = '';
    formData.lineItems.forEach((item: { name: any; rate: any; amount: any; }, index: number) => {
      if (!item.name || !item.rate || !item.amount) {
        let errorMessage = `Line Item ${index+1} Error(s): `;
        if (!item.name) errorMessage += 'Name is required. ';
        if (!item.rate) errorMessage += 'Rate is required. ';
        if (!item.amount) errorMessage += 'Amount is required. ';
        lineItemsErrors += errorMessage.trim() + ' ';
        isValid = false;
      }
    });
    errors.lineItems = lineItemsErrors.trim();
  
  }

  setValidationResults(errors as ICreateExpenseData);
  return isValid;
};



export const validateExpenseTotalPayment = (
  formData: ICreateExpenseData,
  setValidationResults: React.Dispatch<React.SetStateAction<ICreateExpenseData>>,
) => {
  const errors = {
    amount: 0,
    customerId: '',
  };
  let isValid = true;

  if (formData.isBillable === true && !formData.customerId) {
    errors.customerId = 'Select a Customer';
    isValid = false;
  }


  setValidationResults((prevResults) => ({
    ...prevResults,
    ...errors,
  }));

  return isValid;
};


interface ExpenseParams {
  expenseId?: string;
  customer?: ICustomer;
  formData: ICreateExpenseData;
  isBillable: boolean;
}
;

export async function manageExpense({
                              expenseId,
                              customer,
                              formData,
                              isBillable,
                            }: ExpenseParams): Promise<void> {
                              if (formData.lineItems.some((item: { quantity: string; }) => parseFloat(item.quantity) === 0)) {
                                console.log('Quantity is zero for one or more line items. Expense not created.');
                                return;
                              }
  const amount = formData.lineItems
    .map((exp: { rate: string; quantity: string; }) => parseFloat(exp.rate) * parseFloat(exp.quantity) || 0)
    .reduce((prev: any, curr: any) => prev + curr, 0);
  const lineItems = formData.lineItems.map(
    (item: { name: any; rate: any; amount: any; quantity: any; }) => ({
      name: item.name,
      rate: Number(item.rate),
      amount: Number(item.amount),
      quantity: Number(item.quantity),
    }),
  );
  const commonFields = {
    amount,
    isBillable,
    date: new Date(formData.date).toISOString(),
    currency: formData.currency,
    category: formData.category,
    vendorName: formData.vendorName,
    vendorId: formData.vendorId,
    description: formData.description,
    paymentMethod: formData.paymentMethod,
    lineItems: lineItems.length > 0 ? lineItems : undefined,
     notes: formData.notes,
     customerName:customer ? `${customer?.firstName} ${customer?.lastName}` : '',
     customerId: customer?.id ?? '',

  };
  if (!expenseId) {
    const expenseData = {
      ...commonFields,
      customerId: customer?.id ?? '',
      customerName:customer ? `${customer?.firstName} ${customer?.lastName}` : '',
    };
    const response = await createExpense(expenseData as ICreateExpenseData);
    const newExpenseId = response.id;
    console.log('New Expense ID:', newExpenseId);
    return newExpenseId; 
  } else {
    await editExpense(expenseId, commonFields);
    return; 
  }
}


// export const validateExpenseTotalPayment = (
//   formData: ICreateExpenseData,
//   setValidationResults: React.Dispatch<React.SetStateAction<ICreateExpenseData>>,
// ) => {
//   const errors = {
//     amount: 0,
//     customerId: '',
//   };
//   let isValid = true;

  // if (formData.isBillable === false && !formData.customerId) {
  //   errors.customerId = 'Select a Customer';
  //   isValid = false;
  // }

//   setValidationResults(errors as ICreateExpenseData);
//   return isValid;
// };
